<template>
    <div style="margin: 10px 50px">
      <el-form style="margin-right: 20px" :model="subForm" :rules="subRules" ref="subForm" label-width="90px" class="demo-ruleForm">
        <el-form-item label="子机ID" prop="sub_deviceid">
          <el-input v-if="mainDevice.row === ''" placeholder="请输入子机ID" v-model="subForm.sub_deviceid"></el-input>
          <span v-else>{{subForm.sub_deviceid}}</span>
        </el-form-item>
        <el-form-item label="子机类型" prop="sub_type">
          <el-select v-fixZoom :disabled="mainDevice.row !== ''" v-model="subForm.sub_type" placeholder="请选择子机类型" style="width: 100%">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子机名称" prop="sub_name">
          <el-input placeholder="请输入子机名称" v-model="subForm.sub_name"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入备注内容"
            v-model="subForm.remark"></el-input>
        </el-form-item>
      </el-form>
<!--      <div style="text-align: center">-->
<!--        <el-button @click="closeAdd()">取 消</el-button>-->
<!--        <el-button type="primary" @click="submitAddSub('subForm')">确 定</el-button>-->
<!--      </div>-->
      <div>
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAdd()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddSub('subForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 20px"></div>
    </div>
</template>

<script>
import {addsubdevice, updatesubdevice} from '../../../api/device'

export default {
  name: 'addEditSubDevice',
  model: {
    prop: 'addSubShow',
    event: 'change'
  },
  props: {
    mainDevice: {
      type: Object
    }
  },
  data () {
    return {
      subForm: {
        id: 0,
        sub_deviceid: '',
        sub_type: '',
        sub_name: '',
        model: '',
        oem: '',
        main_did: '',
        remark: '',
        imei: ''
      },
      subRules: {
        sub_deviceid: [
          { required: true, message: '请输入子机ID', trigger: 'blur' }
        ],
        sub_type: [
          { required: true, message: '请输入子机类型', trigger: 'blur' }
        ],
        sub_name: [
          { required: true, message: '请输入子机名称', trigger: 'change' }
        ]
      },
      types: []
    }
  },
  created () {
    this.types = this.commonType.getChildDtpyeArr()
    this.subForm.main_did = this.mainDevice.device.id
    this.subForm.imei = this.mainDevice.device.deviceid
    if (this.mainDevice.row === '') {
      this.subForm.id = 0
    } else {
      this.subForm.id = this.mainDevice.row.id
      this.subForm.sub_deviceid = this.mainDevice.row.sub_deviceid
      this.subForm.sub_type = this.mainDevice.row.sub_type
      this.subForm.sub_name = this.mainDevice.row.sub_name
      this.subForm.model = this.mainDevice.row.model
      this.subForm.oem = this.mainDevice.row.oem
      this.subForm.remark = this.mainDevice.row.remark
    }
    // console.log(this.mainDevice)
  },
  mounted () {
  },
  methods: {
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddSub (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.subForm.id === 0) {
            addsubdevice(this.subForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加子机',
                type: 'success',
                duration: 2000
              })
              this.$emit('change', false)
              this.golobleObject.addSubNew()
            }).catch(() => {})
          } else {
            updatesubdevice(this.subForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功编辑子机',
                type: 'success',
                duration: 2000
              })
              this.$emit('change', false)
              this.golobleObject.addSubNew()
            }).catch(() => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addEditSubDevice.vue